<template>
  <div v-if="detail">
    <!-- HERO -->
    <section class="hero-hero d-flex align-items-center justify-content-center" data-aos="fade-up" data-aos-duration="1200">
      <div
        class="hero-bg-img"
        :style="`background-image:url('${detail.hero && detail.hero.image ? detail.hero.image : ''}')`"
      ></div>

      <!-- Overlay -->
      <div class="hero-overlay"></div>

      <!-- Breadcrumb en overlay -->
      <nav
        class="hero-crumbs hero-crumbs--light"
        role="navigation"
        aria-label="breadcrumbs"
      >
        <router-link
          class="crumb-link"
          to="/servicios"
          aria-label="Volver a Servicios"
          :title="crumbServiciosLabel"
        >
          <svg class="crumb-icon" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
            <path fill="currentColor" d="M9.78 3.22a.75.75 0 0 1 0 1.06L6.06 8l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0z"/>
          </svg>
          <span class="crumb-text">{{ crumbServiciosLabel }}</span>
        </router-link>
        <span class="crumb-sep" aria-hidden="true">/</span>
        <span class="crumb-current" aria-current="page">{{ detail.hero.title }}</span>
      </nav>

      <div class="hero-hero-content text-center text-dark">
        <h1 class="display-5 fw-bold hero-hero-title">{{ detail.hero.title }}</h1>
      </div>
    </section>

    <div class="container-xxl automatizacion-body px-1 px-sm-3 pt-4 pb-1">
      <div class="row gx-lg-5">
        <!-- MENU LATERAL DESKTOP -->
        <nav
          class="col-lg-2 d-none d-lg-flex flex-column align-items-start sticky-top"
          style="top:90px;z-index:20;"
          data-aos="zoom-in"
          data-aos-duration="6000"
        >
          <ul class="sidebar-nav">
            <li v-for="item in tab.index" :key="item.anchor">
              <a
                :href="'#'+item.anchor"
                :class="['sidebar-link', {active: activeSection === item.anchor}]"
                @click.prevent="scrollToAnchor(item.anchor)"
              >{{ item.label }}</a>
            </li>
          </ul>
        </nav>

        <!-- NAV HORIZONTAL MOBILE -->
        <div class="col-12 d-lg-none mb-3">
          <div class="mobile-nav px-2 py-1 d-flex flex-wrap gap-2 justify-content-center" data-aos="zoom-in" data-aos-duration="6000">
            <a
              v-for="item in tab.index"
              :key="item.anchor"
              :href="'#'+item.anchor"
              class="mobile-nav-link"
              :class="{active: activeSection === item.anchor}"
              @click.prevent="scrollToAnchor(item.anchor)"
            >{{ item.label }}</a>
          </div>
        </div>

        <!-- MAIN CONTENT -->
        <main class="col-lg-10 px-lg-4">
          <!-- INTRODUCCIÓN -->
          <section :id="tab.index[0].anchor" class="mb-4 intro-section" data-aos="fade-up" data-aos-duration="6000">
            <div class="row align-items-center">
              <div class="col-md-5 text-center mb-2 mb-md-0" data-aos="fade-up" data-aos-duration="6000">
                <img :src="tab.image" :alt="tab.title" class="hero-img img-fluid shadow" />
              </div>
              <div class="col-md-7" data-aos="fade-up" data-aos-duration="6000">
                <h2 class="section-title pt-2 pb-1">{{ tab.title }}</h2>
                <strong class="text-primary d-block mb-1" style="font-size:1.01rem;">{{ tab.index[0].label }}</strong>
                <p class="hero-intro-text" v-html="tab.introduccion.content"></p>
              </div>
            </div>
          </section>
          <hr />

          <!-- ¿Qué incluye el servicio? -->
          <section :id="tab.index[1].anchor" class="mb-5">
            <h3 class="section-title mb-2" data-aos="fade-up" data-aos-duration="6000">{{ tab.index[1].label }}</h3>
            <div class="row d-flex justify-content-end">
              <div class="col-lg-10">
                <div v-if="tab.incluye.description" class="mb-2 small text-muted ps-1" data-aos="fade-up" data-aos-duration="6000">
                  {{ tab.incluye.description }}
                </div>
                <div class="accordion shadow-sm" id="includesAccordion">
                  <div
                    data-aos="fade-up"
                    data-aos-duration="6000"
                    class="accordion-item"
                    v-for="(item, i) in tab.incluye.items"
                    :key="'inc-'+i"
                  >
                    <h2 class="accordion-header" :id="'inc-heading'+i" data-aos="fade-up" data-aos-duration="6000">
                      <button
                        class="accordion-button fw-bold"
                        type="button"
                        :class="{ collapsed: activeAccordion !== i }"
                        @click="activeAccordion = activeAccordion === i ? null : i"
                      >
                        {{ item.title }}
                      </button>
                    </h2>
                    <div
                      :id="'inc-collapse'+i"
                      class="accordion-collapse collapse"
                      :class="{ show: activeAccordion === i }"
                      :aria-labelledby="'inc-heading'+i"
                      data-bs-parent="#includesAccordion"
                    >
                      <div class="accordion-body">
                        <span>{{ item.content }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <hr />

          <!-- Ventajas del Servicio -->
          <section :id="tab.index[2].anchor" class="mb-5">
            <h3 class="section-title mb-3" data-aos="fade-up" data-aos-duration="6000">{{ tab.index[2].label }}</h3>
            <ul class="ventajas-list list-unstyled mt-2">
              <li v-for="(item, i) in tab.ventajas.items" :key="'adv-'+i" data-aos="fade-up" data-aos-duration="6000">
                <span class="check-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18"><path fill="#3d7ecb" d="M7.4 14.3l-4.5-4.6 1.1-1.1 3.4 3.5 6.1-6.1 1.1 1.1z"/></svg>
                </span>
                {{ item }}
              </li>
            </ul>
          </section>
          <hr />

          <!-- Para quién es este servicio -->
          <section :id="tab.index[3].anchor" class="mb-5">
            <h3 class="section-title mb-4" data-aos="fade-up" data-aos-duration="6000">{{ tab.index[3].label }}</h3>
            <div v-if="tab.paraQuien.description" class="mb-3 para-desc" style="font-size:.97em">{{ tab.paraQuien.description }}</div>
            <div class="row g-3">
              <div
                data-aos="fade-up perfil-card" data-aos-duration="6000"
                class="col-md-6 col-lg-6"
                v-for="(perfil, i) in tab.paraQuien.perfiles"
                :key="'perfil-'+i"
              >
                <div class="perfil-card shadow-sm h-100" data-aos="fade-up" data-aos-duration="6000">
                  <span class="perfil-desc">{{ perfil }}</span>
                </div>
              </div>
            </div>
          </section>
          <hr />

          <!-- CTA -->
          <section class="cta-section text-center mt-3 mb-5" data-aos="fade-up" data-aos-duration="6000">
            <div class="cta-inner">
              <h4 class="cta-title fw-bold mb-2" data-aos="fade-up" data-aos-duration="6000">
                <i>{{ detail.cta.title }}</i>
              </h4>
              <div class="cta-content mb-3" data-aos="fade-up" data-aos-duration="6000">{{ detail.cta.content }}</div>
              <button
                data-aos="fade-up" data-aos-duration="6000"
                class="btn btn-sec btn-primary px-4 py-2"
                @click="goToContacto"
                style="border-radius: 25px; font-weight:600; font-size:1rem;">
                {{ detail.cta.button }}
              </button>
            </div>
          </section>
        </main>
      </div>
    </div>
     <!-- Footer abajo de todo -->
    <SiteFooter :selectedLang="selectedLang" />
  </div>
  <div v-else class="alert alert-danger m-5" style="font-family: 'JetBrains Mono', monospace">
    No se pudo cargar el contenido de Automatización y Control.<br />
    Verifica que la data esté bien estructurada e importada.
  </div>
</template>

<script>
import { useSEO } from '@/composables/useSEO';
import { servicios } from '@/assets/data/data.ts';
import SiteFooter from '@/components/SiteFooter.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  name: 'AutomatizacionDeControl',
  components: {
    SiteFooter
  },
  props: {
    selectedLang: {
      type: String,
      required: true
    }
  },
  setup() {
    useSEO({
      title: 'Automatización de Control Industrial',
      description: 'Soluciones de automatización de control con PLC, HMI, SCADA y sistemas distribuidos. Frenkel Engineering optimiza tus procesos industriales de forma inteligente.',
      path: '/automatizacion-de-control',
    });
  },
  data() {
    return {
      activeAccordion: 0,
      activeSection: "introduccion"
    }
  },
  computed: {
    detail() {
      if (
        servicios &&
        servicios['automatizacion-de-control'] &&
        servicios['automatizacion-de-control'].detail &&
        servicios['automatizacion-de-control'].detail[this.selectedLang]
      ) {
        return servicios['automatizacion-de-control'].detail[this.selectedLang];
      }
      return servicios['automatizacion-de-control']?.detail?.es || null;
    },
    tab() {
      return this.detail?.tabs?.[0] || {}
    },
    crumbServiciosLabel() {
      const map = { es: 'Servicios', en: 'Services', de: 'Leistungen' };
      return map[this.selectedLang] || map.es;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScrollSpy);
    AOS.init({
      duration: 800,
      once: true
    });
    setTimeout(() => AOS.refresh(), 300);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScrollSpy);
  },
  methods: {
    scrollToAnchor(anchor) {
      const el = document.getElementById(anchor);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    onScrollSpy() {
      let found = "introduccion";
      for (const section of (this.tab?.index || [])) {
        const el = document.getElementById(section.anchor);
        if (el && window.scrollY + 130 >= el.offsetTop) found = section.anchor;
      }
      this.activeSection = found;
    },
    goToContacto() {
      this.$router.push({ path: '/contacto' });
    },
    goToWhatsApp() {
      const message = encodeURIComponent("¡Hola! Estoy interesado en automatización y control para mi empresa 👋");
      const waUrl = `https://wa.me/525539960462?text=${message}`;
      window.open(waUrl, '_blank');
    }
  }
}
</script>

<style scoped>
/* --- CTA styles ajustados para que se vea igual que Industria 4.0 --- */
.cta-section {
  background: #eef5fc;
  border-radius: 22px;
  max-width: 700px;
  margin: 0 auto;
  padding: 2.3rem 2.1rem 2.7rem 2.1rem;
  box-shadow: 0 3px 24px rgba(44,99,171,0.13);
  border: 2px solid #dbe9fa;
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}
.cta-section:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
.cta-title {
  font-size: 1.35rem;
  color: #28568a;
  letter-spacing: 0.04em;
  font-family: 'JetBrains Mono', monospace;
}
.cta-content {
  font-family: 'Quicksand', sans-serif;
  color: #333;
  font-size: 1.06rem;
  margin-bottom: 0.5rem;
}
.cta-inner .btn {
  background: #181818;
  color: #fff;
  border-radius: 25px;
  font-size: 1.1em;
  font-family: inherit;
  font-weight: 600;
  border: none;
}
.cta-inner .btn:hover {
  background: #0d46a5;
}

/* Mantengo tus estilos originales */
.automatizacion-servicio {
  font-family: 'JetBrains Mono', monospace;
  background: #fafcff;
  color: #1b2230;
  min-height: 100vh;
}
.hero-hero {
  height: 240px;
  min-height: 175px;
  position: relative;
  margin-bottom: 1.6rem;
  background: #fff;
}
.hero-bg-img {
  position: absolute;
  z-index: 1;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: brightness(0.75) blur(0.6px);
}
.hero-overlay {
  position: absolute;
  z-index: 2;
  inset: 0;
  background: linear-gradient(90deg, #fff9 10%, #e6e8ea80 100%);
}
.hero-crumbs {
  position: absolute;
  z-index: 4;
  top: 12px;
  left: 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  line-height: 1;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.hero-crumbs--light {
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(0, 0, 0, 0.08);
  color: #0b2342;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}
.crumb-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  color: inherit;
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.crumb-link:hover { opacity: 0.9; transform: translateX(-1px); }
.crumb-link:focus { outline: 2px solid #0b2342; outline-offset: 2px; }
.crumb-icon { display: inline-block; }
.crumb-sep { opacity: 0.65; margin: 0 2px; }
.crumb-current { opacity: 0.9; font-weight: 600; }

.hero-hero-content {
  z-index: 3;
  position: relative;
  width: 100%;
  padding-top: 0.8em;
}
.hero-hero-title {
  font-family: 'JetBrains Mono', monospace;
  letter-spacing: 0.04em;
  font-size: 2.4rem;
  color: #202026;
}

.sidebar-nav {
  position: sticky;
  top: 100px;
  padding: 0;
  list-style: none;
}
.sidebar-link {
  display: block;
  font-weight: bold;
  color: #2c4366;
  margin-bottom: 0.8rem;
  font-size: 1.01rem;
  border-left: 3px solid transparent;
  padding: 0.16rem 0.7rem 0.16rem 0.65rem;
  border-radius: 3px;
  background: transparent;
  transition: background 0.17s, border-color 0.18s;
}
.sidebar-link.active,
.sidebar-link:hover {
  background: #ececf4;
  color: #1565c0;
  border-left: 3px solid #3d7ecb;
}
.mobile-nav {
  background: #f3f5fb;
  border-radius: 9px;
  font-family: 'JetBrains Mono', monospace;
  font-weight: 700;
}
.mobile-nav-link {
  padding: 0.4em 0.9em;
  color: #28568a;
  text-decoration: none;
  border-radius: 6px;
  font-weight: 600;
  background: transparent;
  font-size: 1rem;
  transition: background .19s, color .13s;
}
.mobile-nav-link.active,
.mobile-nav-link:hover {
  background: #e2e9fa;
  color: #00336d;
}
.section-title {
  font-family: 'JetBrains Mono', monospace;
  font-size: 1.22rem;
  color: #28568a;
  font-weight: 700;
  letter-spacing: 0.03em;
  margin-bottom: 1.1rem;
}
.hero-img {
  border-radius: 12px;
  box-shadow: 0 6px 32px rgba(32,40,80,0.13);
  width: 96%;
  max-width: 320px;
  margin: 0 auto;
  display: block;
  background: #fff;
  border: 1.6px solid #bbb;
  transition: transform 0.4s ease, box-shadow 0.4s ease, filter 0.4s ease, opacity 0.4s ease;
}
.hero-img:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
.hero-intro-text {
  font-size: 1.01rem;
  color: #21285c;
  margin-top: 0.3rem;
  letter-spacing: 0.01em;
  line-height: 1.32;
  font-family: inherit;
  transition: color 0.3s ease;
  position: relative;
  display: inline-block;
}
.hero-intro-text::after{
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 0%;
  background-color: currentColor;
  transition: width 0.3s ease;
}
.hero-intro-text:hover::after{
  width: 100%;
  opacity: .2;
}
.accordion-button {
  font-family: inherit;
  font-size: 1.04rem;
  font-weight: 700;
}
.accordion-body {
  font-size: 0.99rem;
  color: #38405a;
  line-height: 1.5;
}
.accordion-item {
  background: #fff;
}
.ventajas-list {
  margin-left: 0;
  padding-left: 1.3em;
  font-size: 1.02em;
}
.ventajas-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.7em;
  margin-bottom: 0.63em;
  font-size: 0.99rem;
}
.check-icon {
  flex-shrink: 0;
  margin-top: 1px;
}
.perfil-card {
  background: #fff;
  border: 1.5px solid #222;
  border-radius: 11px;
  padding: 1.07em 1.1em 1em 1.1em;
  min-height: 100px;
  font-size: 0.99rem;
  font-family: inherit;
  display: flex;
  align-items: flex-start;
  transition: transform 0.4s ease, box-shadow 0.4s ease, filter 0.4s ease, opacity 0.4s ease;
}
.perfil-card:hover {
  transform: scale(1.05);
  box-shadow: 0 3px 20px rgba(72,136,200,0.06);
}
.perfil-desc {
  font-family: inherit;
  font-weight: 500;
  color: #1b2230;
  font-size: 1em;
}
.btn-sec{
  background-color: #2c74b8;
}
.btn-sec{
  transition: transform 0.4s ease, box-shadow 0.4s ease, filter 0.4s ease, opacity 0.4s ease;
}
.btn-sec:hover{
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
@media (max-width: 991px) {
  .sidebar-nav { display: none; }
  .hero-img { max-width: 220px;}
}
@media (max-width: 767px) {
  .hero-hero { height: 120px; min-height: 70px; }
  .hero-hero-title { font-size: 1.17rem; }
  .hero-img { max-width: 90vw;}
  .perfil-card { min-height: unset; font-size: .96rem; }
  .hero-crumbs { top: 8px; left: 10px; padding: 5px 10px; font-size: 0.85rem; gap: 6px; }
}
@media (max-width: 520px) {
  .hero-img { max-width: 99vw; }
}
</style>
